import BaseProxy from './Proxy';

export default class AutoTopUpRegistrationsProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/autotopup/registrations', parameters);
  }

  list() {
    return this.submit('get', `${this.endpoint}`);
  }

  delete(id, values) {
    return this.submit('post', `${this.endpoint}/delete/${id}`, values);
  }

  determineInitiator(requestorGuid) {
    return this.submit('get', `${this.endpoint}/determineInitiator/${requestorGuid}`);
  }
}
